import { Formik } from 'formik';
import { Form, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import './MemberServiceAccount.scss';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import Header from 'src/Admin/components/common/Header/Header';
import DatePickerComponent from 'src/Admin/components/common/DatePicker';
import useAccountUnlockRecovery from './hooks/useAccountUnlockRecovery';

const AccountUnlockRecovery = () => {
  const {
    email,
    visibleFields,
    initialValues,
    validationSchema,
    verifyUserAccount,
    navigate,
    headingRef,
  } = useAccountUnlockRecovery();

  if (!email) {
    navigate('/member/');
    return null;
  }
  return (
    <Container className="unlock-account-page">
      <div>
        <div
          role="heading"
          aria-level={1}
          className="sr-only"
          tabIndex={-1}
          ref={headingRef}
        >
          Unlock Account
        </div>
        <Header
          linkTo="/member/account-unlock"
          header={'Unlock Account'}
          className="account-recovery-header"
          preserveData={{ email: email || '' }}
        />
      </div>
      <Row>
        <Col>
          <p className="unlock-account-description">
            To Unlock account, fill the information below and enter the email
            you have used to register.
          </p>
        </Col>
      </Row>

      <Row className="account-recovery-form">
        <Col md={8} lg={6}>
          <Formik
            enableReinitialize
            validationSchema={validationSchema}
            initialValues={initialValues}
            onSubmit={(values) => {
              verifyUserAccount(values);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
              submitCount,
              setFieldTouched,
            }) => (
              <Form onSubmit={handleSubmit} className="unlock-account-form">
                <Form.Group className="mb-4" controlId="RegisteredEmail">
                  <Form.Label>
                    Registered Email
                    <span className="required-mark">*</span>
                  </Form.Label>

                  <Form.Control
                    type="email"
                    value={email}
                    disabled
                    readOnly
                    className="registered-email-input"
                  />
                </Form.Group>
                {visibleFields.map((field) => (
                  <Form.Group
                    className="mb-4"
                    key={field.name}
                    controlId={field.name}
                  >
                    <Form.Label>
                      {field.label}
                      {field.visibility === 'Visible' && (
                        <span className="required-mark">*</span>
                      )}
                    </Form.Label>
                    {field.type === 'date' ? (
                      <>
                        <DatePickerComponent
                          name="BirthDate"
                          value={values[field.name] || null}
                          isDOB={field.name === 'dateOfBirth'}
                          showIcon={true}
                          onChange={(date) => {
                            setFieldValue(field.name, date);
                          }}
                          onBlur={() => setFieldTouched(field.name, true)}
                        />
                        {(touched[field.name] || submitCount > 0) &&
                          errors[field.name] && (
                            <div className="date-errors">
                              {errors[field.name]}
                            </div>
                          )}
                      </>
                    ) : (
                      <Form.Control
                        type={field.type}
                        name={field.name}
                        value={values[field.name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          (touched[field.name] || submitCount > 0) &&
                          !!errors[field.name]
                        }
                      />
                    )}

                    <Form.Control.Feedback type="invalid">
                      {errors[field.name]}
                    </Form.Control.Feedback>
                  </Form.Group>
                ))}

                <Row className="unlock-account-actions">
                  <div>
                    <Link to="/member" className="return-login-link">
                      Return to Login
                    </Link>
                  </div>

                  <div className="text-right">
                    <GenericButton type="submit" variant="primary">
                      SUBMIT
                    </GenericButton>
                  </div>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export default AccountUnlockRecovery;
